export default __webpack_public_path__ + "static/media/OtherScanner.8d655c0c.svg";